import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useTeamAncestors } from "@/hooks/queries/use-teams";

interface TeamBreadcrumbProps {
  teamId: string;
}

export function TeamBreadcrumb({ teamId }: TeamBreadcrumbProps) {
  const { data: ancestors, isLoading } = useTeamAncestors(teamId);

  if (isLoading) {
    return <div className="h-5 w-56 animate-pulse rounded bg-muted/60" />;
  }

  if (!ancestors || ancestors.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Team breadcrumb" className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
      <Link to="/teams" className="transition-colors hover:text-foreground">
        Teams
      </Link>
      {ancestors.map((team, index) => {
        const isCurrent = index === ancestors.length - 1;

        return (
          <div key={team.id} className="flex items-center gap-1">
            <ChevronRight className="h-3.5 w-3.5" />
            {isCurrent ? (
              <span className="font-medium text-foreground">{team.name}</span>
            ) : (
              <Link to={`/teams/${team.id}`} className="transition-colors hover:text-foreground">
                {team.name}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
